<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>CONDUCTORES</strong></h2>
    </div>

    <div class="d-flex justify-content-between mb-3">
      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Celular</th>
            <th>Correo</th>
            <th>Num. Licencia</th>
            <th>Tipo</th>
            <th>Fecha Vig. Licencia</th>
            <th>Disponibilidad</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="conductor in paginatedConductores" :key="conductor.Id_conductor">
            <td>{{ conductor.Id_conductor }}</td>
            <td>{{ conductor.Nombre }}</td>
            <td>{{ conductor.Celular }}</td>
            <td>{{ conductor.Correo }}</td>
            <td>{{ conductor.Licencia }}</td>
            <td>{{ conductor.Tipo }}</td>
            <td>{{ conductor.Fecha_vigencia }}</td>
            <td>{{ conductor.Disponibilidad }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lista_conductores: [],
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredConductores() {
      return this.lista_conductores.filter((conductor) => {
        const searchString = `${conductor.Id_conductor} ${conductor.Nombre} ${conductor.Celular} ${conductor.Correo} ${conductor.Folio} ${conductor.Disponibilidad}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedConductores() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredConductores.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.filteredConductores.length / this.itemsPerPage);
    },
  },
  methods: {
    getConductores() {
      fetch(
        this.$backendUrl+ "/index.php/conductores/lista_completa"
      )
        .then((response) => response.json())
        .then((data) => {
          this.lista_conductores = data;
        });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getConductores();
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  text-align: center;
}

.table {
  width: 100%;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349; 
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; 
}
</style>
